export default __webpack_public_path__ + "static/media/logo.eb28cb1c.png";